import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h4", null, "Attribute Hub", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("h4", null, "Attribute Target", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h4", null, "Action", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_5 = { style: {"margin":"auto 2px"} }
const _hoisted_6 = /*#__PURE__*/_createVNode("h4", null, "Shipping Method Hub", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("h4", null, "Shipping Method Target", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("h4", null, "Action", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_10 = /*#__PURE__*/_createVNode("h4", null, "Payment Method Hub", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("h4", null, "Payment Method Target", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("h4", null, "Action", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_14 = {
  class: "dialog-footer",
  style: {"margin-top":"1rem","text-align":"right"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Refresh ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Save")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.typeMapping === 'Attribute')
      ? (_openBlock(), _createBlock(_component_el_form, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "padding",
              justify: "space-around"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { lg: 11 }, {
                  default: _withCtx(() => [
                    _hoisted_1,
                    (_ctx.listAttributesFrom.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 0,
                          modelValue: _ctx.dataFormMapping.saas,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataFormMapping.saas = $event)),
                          filterable: "",
                          placeholder: "----Select---",
                          style: {"width":"100%"},
                          onChange: _ctx.handleSelectAttributeFrom
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAttributesFrom, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: item,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 128)),
                            _createVNode(_component_el_option, {
                              label: "Custom",
                              value: "attributeFromCustom"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"]))
                      : _createCommentVNode("", true),
                    (_ctx.listAttributesFrom.length === 0 || _ctx.isAttributeFromCustom)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 1,
                          class: _ctx.isAttributeFromCustom ? 'padding' : '',
                          modelValue: _ctx.dataFormMapping.valueAttributeFromCustom,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataFormMapping.valueAttributeFromCustom = $event)),
                          placeholder: "Please input"
                        }, null, 8, ["class", "modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 11 }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.dataFormMapping.connect,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataFormMapping.connect = $event)),
                      filterable: "",
                      onChange: _ctx.handleSelectAttribute,
                      placeholder: "----Select---",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAttributes, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128)),
                        _createVNode(_component_el_option, {
                          label: "Custom",
                          value: "attributeCustom"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]),
                    (_ctx.isAttributeCustom)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          class: "padding",
                          placeholder: "Please input",
                          modelValue: _ctx.dataFormMapping.valueAttributeCustom,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataFormMapping.valueAttributeCustom = $event))
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 2 }, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createVNode(_component_el_button, {
                      type: "success",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleAddAttribute()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.dataFormMappingAttribute)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  data: _ctx.dataFormMappingAttribute,
                  border: "",
                  size: "small",
                  style: {"width":"100%","margin-top":"20px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "saas",
                      label: "Hub's Attribute"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "connect",
                      label: "Target's Attribute"
                    }),
                    _createVNode(_component_el_table_column, { width: "70px" }, {
                      default: _withCtx((scope) => [
                        _createVNode("div", _hoisted_5, [
                          (!scope.row.isHiddenButtonRemove)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                size: "small",
                                type: "danger",
                                icon: "el-icon-delete",
                                onClick: ($event: any) => (_ctx.handleRemoveOption(scope.$index - 6))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.typeMapping === 'Shipping' )
      ? (_openBlock(), _createBlock(_component_el_form, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "padding"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { lg: 10 }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    (_ctx.listShippingCarriersFrom.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 0,
                          modelValue: _ctx.dataFormMapping.connect,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dataFormMapping.connect = $event)),
                          placeholder: "----Select---",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listShippingCarriersFrom, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: item.value,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock(_component_el_input, {
                          key: 1,
                          modelValue: _ctx.dataFormMapping.connect,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataFormMapping.connect = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 10 }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    (_ctx.listShippingCarriers.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 0,
                          modelValue: _ctx.dataFormMapping.saas,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dataFormMapping.saas = $event)),
                          placeholder: "----Select---",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listShippingCarriers, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: item.value,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock(_component_el_input, {
                          key: 1,
                          modelValue: _ctx.dataFormMapping.saas,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dataFormMapping.saas = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 4 }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createVNode(_component_el_button, {
                      type: "success",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleAddShipping()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.dataForm.mappingShipping)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  data: _ctx.dataForm.mappingShipping,
                  border: "",
                  size: "small",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "connect",
                      label: "Attribute"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "saas",
                      label: "Attribute SAAS"
                    }),
                    _createVNode(_component_el_table_column, { "min-width": "50px" }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "danger",
                          icon: "el-icon-delete",
                          onClick: ($event: any) => (_ctx.handleRemoveOption(scope.$index))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.typeMapping === 'Payment' )
      ? (_openBlock(), _createBlock(_component_el_form, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "padding"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { lg: 10 }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    (_ctx.listPaymentCarriersFrom.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 0,
                          modelValue: _ctx.dataFormMapping.connect,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dataFormMapping.connect = $event)),
                          placeholder: "----Select---",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listPaymentCarriersFrom, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: item.value,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock(_component_el_input, {
                          key: 1,
                          modelValue: _ctx.dataFormMapping.connect,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dataFormMapping.connect = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 10 }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    (_ctx.listPaymentCarriers.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 0,
                          modelValue: _ctx.dataFormMapping.saas,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dataFormMapping.saas = $event)),
                          placeholder: "----Select---",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listPaymentCarriers, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: item.value,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock(_component_el_input, {
                          key: 1,
                          modelValue: _ctx.dataFormMapping.saas,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dataFormMapping.saas = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { lg: 4 }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "success",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleAddPayment()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.dataForm.mappingPayment)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  data: _ctx.dataForm.mappingPayment,
                  border: "",
                  size: "small",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "connect",
                      label: "Attribute"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "saas",
                      label: "Attribute SAAS"
                    }),
                    _createVNode(_component_el_table_column, { "min-width": "50px" }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "danger",
                          icon: "el-icon-delete",
                          onClick: ($event: any) => (_ctx.handleRemoveOption(scope.$index))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_14, [
      _createVNode(_component_el_button, {
        size: "small",
        type: "success",
        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.getConnectMapping()))
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleSaveMapping()))
      }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      })
    ])
  ], 64))
}